module.exports = "/_next/static/images/48e8b93e8dd6847f140e1d9e5fce21a6-slide1mobile.jpg.webp";